// extracted by mini-css-extract-plugin
export var blockquote = "Quote-module--blockquote--f7cb3";
export var margin = "Quote-module--margin--4c178";
export var quote = "Quote-module--quote--ce544";
export var quoteFirst = "Quote-module--quoteFirst--4d613";
export var quoteSecond = "Quote-module--quoteSecond--9abfd";